/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';
import startEditingNewReport from './start-editing-new-report';

export default (reportId, report) => (dispatch) => {
	if (!reportId) {
		return dispatch(startEditingNewReport(report));
	}
	dispatch({ type: actions.REPORT_BUILDER_START, payload: { reportId, report } });
};
